import Abstract from './_abstract.js';
import Twig from 'twigjs';

class WordPress extends Abstract {

	/**
	 * @inheritdoc
	 */
	loadTemplates() {
		Twig.twig( {
			id: 'pagination',
			href: '/wp-content/themes/kendal/views/partials/pagination.twig',
		} );

		Twig.twig( {
			id: 'result',
			href: '/wp-content/themes/kendal/views/partials/search/kcard.twig',
		} );
	}

	/**
	 * @inheritdoc
	 */
	getQueryString() {
		// build our query string from our filters
		let queryString = '';

		if ( this.params.q ) {
			queryString += `&q=${encodeURIComponent(this.params.q)}`;
		}

		if ( this.params.paged > 1 ) {
			queryString += `&paged=${this.params.paged}`;
		}

		return queryString.replace( /^&/, '' );
	}

	/**
	 * @inheritdoc
	 */
	getXhrUrl( queryString ) {
		let url = window.location.pathname.replace( /\/page\/\d+\/?$/, '/' );
		url += `?${queryString ? queryString + '&' : ''}json=1`;

		return url;
	}
}

export default WordPress;
